"use strict";
// global options
Object.defineProperty(exports, "__esModule", { value: true });
exports.options = {
    disableErrorLog: false
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoib3B0aW9ucy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9vcHRpb25zLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSxpQkFBaUI7O0FBRUosUUFBQSxPQUFPLEdBQUc7SUFDbkIsZUFBZSxFQUFHLEtBQUs7Q0FDMUIsQ0FBQSJ9